import { render, staticRenderFns } from "./ListaNotificaciones.vue?vue&type=template&id=6c232234&scoped=true"
import script from "./ListaNotificaciones.vue?vue&type=script&lang=js"
export * from "./ListaNotificaciones.vue?vue&type=script&lang=js"
import style0 from "./ListaNotificaciones.vue?vue&type=style&index=0&id=6c232234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c232234",
  null
  
)

export default component.exports